import { node } from "prop-types";
import { useSelector } from "react-redux";
import * as prismic from "@prismicio/client";
import { PrismicProvider, PrismicToolbar } from "@prismicio/react";
import { sanitize } from "dompurify";

import { PRISMIC_REPO } from "../../constants/site";

import prismicLinkResolver from "./helpers/prismic-link-resolver";

export const client = prismic.createClient(PRISMIC_REPO);

function PrismicApp({ children }) {
  const authenticated = useSelector(state => !!state?.login.auth.expires);
  const userRole = useSelector(state => state?.login?.user?.role);

  return (
    <PrismicProvider
      richTextComponents={{
        embed: formatPrismicEmbed,
        label: formatPrismicLabel,
      }}
      client={client}
      linkResolver={prismicLinkResolver}
    >
      {children}
      {authenticated && userRole === "admin" && (
        <PrismicToolbar repositoryName={PRISMIC_REPO} />
      )}
    </PrismicProvider>
  );
}

function formatPrismicEmbed({ node, key }) {
  const html = node.oembed.html ?? "";
  const clean = sanitize(html, {
    ALLOWED_TAGS: ["iframe"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"],
    FORBID_ATTR: ["width", "height"],
  });

  return (
    <div className="embed">
      <div
        key={key}
        data-oembed={node.oembed.embed_url}
        data-oembed-type={node.oembed.type}
        data-oembed-provider={node.oembed.provider_name}
        dangerouslySetInnerHTML={{ __html: clean ?? "" }}
      />
    </div>
  );
}

function formatPrismicLabel({ node, children, key }) {
  let label = node?.data?.label;

  switch (label) {
    case "superscript":
      return <sup key={key}>{children}</sup>;
    default:
      return (
        <span key={key} className={node.data.label}>
          {children}
        </span>
      );
  }
}

PrismicApp.propTypes = {
  children: node.isRequired,
};

export default PrismicApp;
